import $ from 'jquery';

export default class Filters {
    constructor() {
        if($('.js-filters').length) {
            const $this = $('.js-filters__toggle');

            $this.on('click', function() {
                $this.parent().toggleClass('is-active');
            });
        };
    };
};
